/**
 * Helpers for the driver single-device session id.
 *
 * The id is minted by `driver-login` on every successful OTP verification and
 * persisted to `localStorage`. Every privileged driver-side `dispatch-trip`
 * action should pass it so the server can reject calls coming from a device
 * whose session has been replaced by a newer login on another device.
 */
export const DRIVER_SESSION_KEY = 'driver_session_id';
export const SESSION_INVALIDATED_EVENT = 'driver-session-invalidated';

export function getDriverSessionId(): string | null {
  try {
    return localStorage.getItem(DRIVER_SESSION_KEY);
  } catch {
    return null;
  }
}

export function setDriverSessionId(id: string | null) {
  try {
    if (id) localStorage.setItem(DRIVER_SESSION_KEY, id);
    else localStorage.removeItem(DRIVER_SESSION_KEY);
  } catch { /* ignore */ }
}

/**
 * Inspect a `dispatch-trip` invoke result and broadcast a global
 * `driver-session-invalidated` event when the backend reports that the
 * session id no longer matches the current `drivers.active_session_id`.
 * `useDriverAuth` listens for this event and forces a sign-out.
 */
export function handleDispatchResult(res: any) {
  const err = res?.data?.error || res?.error?.message;
  if (typeof err === 'string' && err === 'session_invalidated') {
    try {
      window.dispatchEvent(new CustomEvent(SESSION_INVALIDATED_EVENT));
    } catch { /* ignore */ }
  }
  return res;
}